import { AppNS } from 'app';
import { ApiNS } from 'app/api/api';
import { apiGetReportsForInspections } from 'app/api_v2/qa-reports';
import { getAdminLink } from 'app/core/layout/components/Navigation/users-config/agency';

export const INSPECTIONS_TABS = [
  {
    name: 'Scheduled Inspections',
    slug: 'upcoming',
    disabled: false,
  },
  {
    name: 'Inspections In Progress',
    slug: 'in_progress',
    disabled: false,
  },
  {
    name: 'Inspections In QA',
    slug: 'in_qa',
    disabled: false,
  },
  {
    name: 'Ready For Issuance',
    slug: 'ready_for_issuance',
    disabled: false,
  },
  {
    name: 'Completed',
    slug: 'completed',
    disabled: false,
  },
];

const extractIds = (data: AppNS.JobEventReport[]): string[] => {
  return data.map((item) => item.id);
};

export const combineResults = async (
  inspectionsData: ApiNS.ReportsListResponse | undefined,
  signal?: AbortSignal
): Promise<ApiNS.ReportsListResponse> => {
  if (!inspectionsData) {
    return Promise.resolve({ results: [], totalPages: 0, totalEntries: 0, totalAmount: 0 });
  }
  const ids = extractIds(inspectionsData?.results || []);
  if (!ids.length) {
    return inspectionsData;
  }

  const reports = await apiGetReportsForInspections(ids, signal);

  return {
    ...inspectionsData,
    results: inspectionsData.results.map((item: AppNS.JobEventReport) => {
      const qaReport = reports.results?.find((d) => d.eventReportId === item.id);
      return qaReport ? { ...item, qaReport } : item;
    }),
  };
};

export const getInspectionExternalLink = (inspectionId: string) => {
  const adminLink = getAdminLink();
  return `${adminLink}/inspection-report/${inspectionId}`;
};

export const getProjectExternalLink = (projectId: string) => {
  const adminLink = getAdminLink();
  return `${adminLink}/project/${projectId}`;
};
